import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Seo } from "@/components/Seo";
import { businessLd, personLd, websiteLd, faqLd } from "@/lib/seo";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { Hero } from "@/components/Hero";
import { Ribbon } from "@/components/Ribbon";
import { CaseJourney } from "@/components/CaseJourney";
import { CapabilityJourney } from "@/components/CapabilityJourney";
import { Manifesto } from "@/components/Manifesto";
import { Markets } from "@/components/Markets";
import { InsightsPreview } from "@/components/InsightsPreview";
import { HomeFaq, HOME_FAQ } from "@/components/HomeFaq";
import { Booking } from "@/components/Booking";
import { Contact } from "@/components/Contact";

export default function Landing() {
  const loc = useLocation();

  useEffect(() => {
    if (loc.hash) {
      const id = loc.hash.replace("#", "");
      setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" }), 200);
    }
  }, [loc]);

  return (
    <div data-testid="landing-page">
      <Seo
        title="Employee Relations & People Risk Advisory | Dubai & Middle East"
        path="/"
        jsonLd={[businessLd, personLd, websiteLd, faqLd(HOME_FAQ)]}
      />
      <Header />
      <main>
        <Hero />
        <Ribbon />
        <CaseJourney />
        <CapabilityJourney />
        <Manifesto />
        <Markets />
        <InsightsPreview />
        <HomeFaq />
        <Booking />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
